import type { Action } from "../../actions/types";

export interface LoyaltyQuestTokenData {
  // TODO: Define proper interface based on LoyaltyQuest API response
  // This will depend on what the merchant SDK returns
  error?: boolean | null;
  token: string;
  clientId: string;
  merchantId: string;
}

export type StoreState = LoyaltyQuestTokenData | null;

export const initialState: StoreState = null;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "LOYALTYQUEST_TOKEN_SUCCESS":
      return {
        ...state,
        ...action.response.data,
      } as LoyaltyQuestTokenData;

    case "LOYALTYQUEST_TOKEN_FAILURE":
      return null;

    default:
      return state;
  }
}
